import { useState, useCallback } from 'react';

const API_BASE = '';

export interface AuthUser {
  id: string;
  name: string;
  login: string;
  role: string;
  email: string;
}

export interface ManagerInfo {
  name: string;
  telegram: string;
  email: string;
  avatar: string | null;
}

const AUTH_KEY = 'portal_auth_user';
const MANAGER_KEY = 'portal_manager';

export function getStoredUser(): AuthUser | null {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? (JSON.parse(raw) as AuthUser) : null;
  } catch {
    return null;
  }
}

export function getStoredManager(): ManagerInfo | null {
  try {
    const raw = localStorage.getItem(MANAGER_KEY);
    return raw ? (JSON.parse(raw) as ManagerInfo) : null;
  } catch {
    return null;
  }
}

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(getStoredUser);

  const login = useCallback(async (loginVal: string, password: string): Promise<boolean> => {
    try {
      const resp = await fetch(`${API_BASE}/api/portal/auth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: loginVal.trim(), password }),
      });
      const data = await resp.json();

      if (!data.ok) return false;

      const authUser: AuthUser = {
        id: data.user.username,
        name: data.user.full_name,
        login: data.user.username,
        role: 'chat-operator',
        email: '',
      };
      localStorage.setItem(AUTH_KEY, JSON.stringify(authUser));

      if (data.user.manager) {
        const manager: ManagerInfo = {
          name: data.user.manager.name,
          telegram: data.user.manager.telegram,
          email: data.user.manager.email,
          avatar: data.user.manager.avatar,
        };
        localStorage.setItem(MANAGER_KEY, JSON.stringify(manager));
      }

      setUser(authUser);
      return true;
    } catch (e) {
      console.error('Auth error:', e);
      return false;
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(MANAGER_KEY);
    setUser(null);
  }, []);

  return { user, login, logout };
}
